export default "__VITE_ASSET__77c0fb22__"